var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-padding-x"},[_c('span',[_vm._v(_vm._s(_vm.getPercentage + '%'))]),_vm._v(" "),_c('progress',{staticClass:"progress",class:_vm.computedClass,attrs:{"max":_vm.maxVal},domProps:{"value":_vm.currentValue}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-160cd332","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Progress.vue
// module id = null
// module chunks = 